import { DONATE_AMOUNTS } from '../../constants'

import FormInput from '../../components/FormInput'
import { Collapse } from '@material-ui/core'

import { formValidation, locationLookup } from '../../helpers'

const gridParams = { item: true, spacing: 3 }
const DonateInputs = ({
  onSelectAmount,
  onConfirmAmount,
  onError,
  formRefs,
  formErrors,
  formData,
  classes,
}) => {
  const [reminder, setReminder] = useState(false)
  const [showGo, setShowGo] = useState(false)
  const [amountClicked, setAmountClicked] = useState(false)
  const onClickAmount = (pounds) => {
    setAmountClicked(true)
    onSelectAmount('amount', { target: { value: pounds } })
  }

  useEffect(() => {
    if (!!formData.amount && amountClicked) {
      submit()
    }
  }, [formData])

  const submit = () => {
    setReminder(false)
    let validation = formValidation(formRefs, formErrors)
    if (!formData.amount) {
      validation = { valid: false, errors: {} }
      setReminder(true)
    }
    if (validation.valid) {
      onConfirmAmount()
    } else {
      onError(validation.errors)
    }
  }

  return (
    <Grid {...gridParams} container component="form">
      {reminder && (
        <Fade in={reminder}>
          <Grid item xs={12}>
            <Typography variant="h5">Please select an amount</Typography>
          </Grid>
        </Fade>
      )}
      {DONATE_AMOUNTS.split(',').map((pounds) => (
        <Grid item xs={4} key={pounds}>
          <Button
            variant="contained"
            color={pounds * 100 === formData.amount ? 'secondary' : 'primary'}
            fullWidth
            onClick={() => onClickAmount(pounds)}
          >
            £{pounds}
          </Button>
        </Grid>
      ))}
      <Grid item xs={8}>
        <FormInput
          onChange={onSelectAmount}
          formErrors={formErrors}
          fieldName="amount"
          formData={formData}
          formRefs={formRefs}
          uncontrolled
          onFocus={() => setShowGo(true)}
        />
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={12} md={8} lg={6} className={classes.buttonContainer}>
          <Collapse in={showGo}>
            <Button variant="contained" color="secondary" fullWidth onClick={submit}>
              Go
            </Button>
          </Collapse>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DonateInputs
